module.exports = {
      id: "launcher-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#launcher",
      toString: function () {
        return this.url;
      }
    }